var headerController = {};

headerController.loadHeaderApp = function($newcontent) {
    $.ajax({
        type: "GET",
        url: "app/templates/header.mustache",
        dataType: "text",
        async: true
    }).done(function (data) {
        var $htmlContent = $(htmlText);

        var dataTypeNavigationMenu = $($newcontent).find("[data-type-navigation='menu']");
        var dataTypeNavigationBack = $($newcontent).find("[data-type-navigation='back']");

        if ( dataTypeNavigationBack.length > 0 ) {
            var properties = {"isBack": true};
            var htmlText = Mustache.render(data, properties);
            $htmlContent = $(htmlText);
        }
        else {
            var properties = {"isMenu": true};
            var htmlText = Mustache.render(data, properties);
            $htmlContent = $(htmlText);
        }

        $("#app-content").find("[data-role='header']").replaceWith($htmlContent);
    });
}

headerController.loadHeaderDoc = function($newcontent) {
    if ( psa_params.data.isDoc == undefined ) {
        $.ajax({
            type: "GET",
            url: "doc/templates/header.mustache",
            dataType: "text",
            async: true
        }).done(function (data) {
            var $htmlContent = null;
            var properties = {};

            var dataTypeNavigationMenu = $($newcontent).find("[data-category-screen='home'], [data-category-screen='menu']");
            var dataTypeNavigationDetails = $($newcontent).find("[data-category-screen='details']");

            if ( dataTypeNavigationDetails.length > 0 ) {
                var properties = {"isBack": true};
            }
            else {
                var properties = {"isMenu": true};
            }

            if ( vehicleManager.uuidVersionSelected != null ) {
                var version = getListeVersionVehicule()[vehicleManager.uuidVersionSelected];
                properties.name = version.name;

                if ( version.title ) {
                    properties.title = version.title;
                }
            }

            var htmlText = Mustache.render(data, properties);
            $htmlContent = $(htmlText);

            $("#app-content").find("[data-role='header']").replaceWith($htmlContent);
        });
    }
}
